import template from "./index.html";
import onboardingModeMessage from "./onboarding-mode-message.js";
import onboardingModeDefault from "./onboarding-mode-default.js";
import onboardingModeForm from "./onboarding-mode-form.js";

function controller() {
	const ctrl = this;

	ctrl.$onChanges = (changes) => {
		if(changes.selectedForm) {
			const requestModeCode = ctrl.selectedForm?.Onboarding?.Requests?.Mode?.Code;

			ctrl.isMessagingMode = requestModeCode === "MESSAGE";
			ctrl.isFormMode = requestModeCode === "FORM";
		}
	};
}

export default angular
	.module("vesl.screens.welcome.onboarding-mode-handler", [onboardingModeMessage, onboardingModeDefault, onboardingModeForm])
	.component("onboardingModeHandler", {
		bindings: {
			selectedForm: "<"
		},
		controller,
		template
	}).name;
